import React, { useState, useEffect, useMemo, useRef } from 'react'
import flatpickr from 'flatpickr'
import moment from 'moment-timezone'
import { parse } from 'date-fns'
import { FoundationsButton } from '../../GenericComponents/button'
import {
    useGetRequestersMutation,
    useGetSettingsMutation,
    useGetLeaveDetailsMutation,
    useCreateOrUpdateLeaveRequestMutation,
} from '../../Redux/LeaveManager/LeaveMangerSlice'
import { LMS_LeaveRequestStatus } from '../../Redux/LeaveManager/LmsEnums'
import Dialog from '../../GenericComponents/dialog'
import { FoundationsInput } from '../../GenericComponents/input'
import { FoundationsTextArea } from '../../GenericComponents/textarea'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentUserData, RootState } from '../../Redux/store'
import { clearLmsId, setnewForm } from '../../Redux/LeaveManager/LmsIdSlice'
import ShiftSection from './ShiftAndRecommendations'
import { formatDate, genericValueToEnum } from '../../Utils'
import { FoundationsEnums } from '../../enum'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { checkType1OrHasPrivilege } from '../../GlobalMethods'

declare let window: any
interface Requester {
    key: string | number
    value: string
}
export interface LeaveManagerApiDTO_LeaveApplication {
    id?: number
    requester: ApiDTO_MinimalUser
    vacationType: number
    requestStatus: number
    startingDateTime: string | Date
    endingDateTime: string | Date
    ts_creationDateTime: Date
    ts_modificationDateTime: Date
    modifiedByUser: ApiDTO_MinimalUser
    approvedByUser: ApiDTO_MinimalUser
    comments: LeaveManagerApiDTO_LeaveComments[]
    lastReadByCurrentUser: Date
    user: ApiDTO_MinimalUser
}

export interface LeaveManagerApiDTO_LeaveComments {
    id: number
    requestId: number
    ts_creationDateTime: Date
    postedBy: ApiDTO_MinimalUser
    postedByUser: ApiDTO_MinimalUser
    Comment: string
}

export interface ApiDTO_MinimalUser {
    id?: number
    displayName: string
    jsonSafeId: number
}

const LeaveManagementForm = () => {
    const currentUserData = useSelector(
        (state: RootState) => getCurrentUserData(state)
    )
    let newForm = useSelector((state: RootState) => state.lms.newForm)
    let lmsId = useSelector((state: RootState) => state.lms.lmsId)
    const dispatch = useDispatch()
    const initialLeaveApplication: LeaveManagerApiDTO_LeaveApplication = {
        requester: { jsonSafeId: -1, id: 0, displayName: '' },
        vacationType: 1,
        requestStatus: LMS_LeaveRequestStatus.New,
        startingDateTime: '',
        endingDateTime: '',
        ts_creationDateTime: new Date(),
        ts_modificationDateTime: new Date(),
        lastReadByCurrentUser: new Date(),
        modifiedByUser: { jsonSafeId: -1, id: -1, displayName: '' },
        approvedByUser: { jsonSafeId: -1, id: -1, displayName: '' },
        user: { jsonSafeId: -1, id: -1, displayName: '' },
        comments: [],
    }
    const leaveComment: LeaveManagerApiDTO_LeaveComments = {
        id: -1,
        requestId: -1,
        ts_creationDateTime: new Date(),
        postedBy: {
            id: -1,
            jsonSafeId: -1,
            displayName: '',
        },
        postedByUser: {
            id: -1,
            jsonSafeId: -1,
            displayName: '',
        },

        Comment: '',
    }

    const [leaveApplication, setLeaveApplication] =
        useState<LeaveManagerApiDTO_LeaveApplication>(initialLeaveApplication)
    const [requesterName, setRequesterName] = useState<string>('')
    const [selectedRequesterKey, setSelectedRequesterKey] = useState<number | string | null>(null)
    const [canEditProvider, setcanEditProvider] = useState<boolean>(false)
    const [showDialog, setShowDialog] = useState<boolean>(false)
    const [updateClicked, setupdateClicked] = useState<boolean>(false)
    const [clearClicked, setClearClicked] = useState<boolean>(false)
    const [showShiftSection, setShowShiftSection] = useState<boolean>(false)
    const [comment, setComment] = useState<string>('')
    const [requester, setRequester] = useState<ApiDTO_MinimalUser | null>(null)
    const [formType, setformType] = useState<string>('requester')
    const [settings, setSettings] = useState<any>({
        vacationTypes: [],
        leaveStatusList: [],
    })
    const [isLoadingButton, setIsLoadingButton] = useState<any>(null);
    const [requesters, setRequesters] = useState<Requester[] | null>(null)
    const [originalRequesters, setOriginalRequesters] = useState<Requester[]>([])
    const [searchText, setSearchText] = useState<string>('')
    const [totalDays, setTotalDays] = useState(0)
    const [error, setError] = useState('')
    const [dateError, setdateError] = useState<boolean>(false)
    const inputRef = useRef<HTMLInputElement>(null)
    const vacationTypeLabel =
        settings.vacationTypes.find((x: any) => x.id === leaveApplication.vacationType)?.Label || ''
    const [
        GetRequesters,
        { data: requestersAPI, error: requesterError, isLoading: requesterLoading },
    ] = useGetRequestersMutation()
    const [GetSettings, { data: Settings, error: settingsError, isLoading: settingsLoading }] =
        useGetSettingsMutation()
    const [
        GetLeaveDetails,
        { data: LeaveDetails, error: leaveDetailsError, isLoading: leaveDetailsLoading },
    ] = useGetLeaveDetailsMutation()
    const [
        CreateOrUpdateLeaveRequest,
        { data: resLeaveRequest, error: resLeaveRequestError, isLoading: resLeaveRequestLoading },
    ] = useCreateOrUpdateLeaveRequestMutation()
    
    useEffect(() => {
        if (!newForm && inputRef.current) {
            inputRef.current.focus()
            inputRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
    }, [newForm, lmsId])

    useEffect(() => {
        const fetchData = async () => {
            try {
                let fetchedRequesters: Requester[] = requesters || []
                let fetchedSettings: { vacationTypes: []; leaveStatusList: [] }
                let fetchedLeaveApplication: LeaveManagerApiDTO_LeaveApplication =
                    initialLeaveApplication
                let fetchedFormType = ''

                

                if (!fetchedRequesters.length) {
                    const requestersResult = await GetRequesters().unwrap()
                    fetchedRequesters = requestersResult.Requesters || []
                }

                const settingsResult = await GetSettings().unwrap()
                fetchedSettings = {
                    vacationTypes: settingsResult.VacationTypes.filter((x: any) => x.id > 0) || [],
                    leaveStatusList:
                        settingsResult.LeaveStatusList.filter((x: any) => x.id > 0) || [],
                }

                if (lmsId != null && !newForm) {
                    setComment('')
                    setError('')
                    const leaveApplication = await GetLeaveDetails(lmsId).unwrap()
                    fetchedLeaveApplication = leaveApplication || {}
                    if (checkType1OrHasPrivilege(currentUserData,'LeaveRequestManager')) {
                        fetchedFormType =
                            leaveApplication.user.id !== currentUserData.id
                                ? 'approver'
                                : 'requester'
                    }
                    else {
                        if (leaveApplication?.MessageResults?.length) {
                            leaveApplication.MessageResults.forEach((result: any) => {
                                if (result.HelpMessage === FoundationsEnums.Status.Failure) {
                                    FoundationsGenericToaster('error', result.Message)
                                    lmsId = null
                                }
                            })
                        }
                    }
                } else {
                    fetchedFormType = 'requester'
                    const providerId = currentUserData.providerId
                    const provider = fetchedRequesters.find(
                        (item) => Number(item.key) === providerId
                    )
                    const requester = {
                        id: providerId,
                        jsonSafeId: providerId,
                        displayName: provider?.value || '',
                    }

                    fetchedLeaveApplication = {
                        ...fetchedLeaveApplication,
                        requester,
                        user: currentUserData,
                    }
                }
                setRequesters(fetchedRequesters)
                setOriginalRequesters(fetchedRequesters)
                setSettings(fetchedSettings)
                setLeaveApplication(fetchedLeaveApplication)
                setformType(fetchedFormType)

                if (fetchedLeaveApplication.requester) {
                    setRequester(fetchedLeaveApplication.requester)
                }
            } catch (err) {
                console.error('Error fetching data:', err)
            }
        }

        fetchData()
    }, [lmsId, clearClicked])

    useEffect(() => {
        if (formType !== 'approver' && checkType1OrHasPrivilege(currentUserData,'LeaveRequestManager')) {
            setcanEditProvider(true)
        } else {
            setcanEditProvider(false)
        }
    }, [formType])

    useEffect(() => {
        let totalDays = 0
        let lowerBoundDate = new Date(new Date().setDate(new Date().getDate() - 30))
        let minDate = leaveApplication.startingDateTime
            ? new Date(leaveApplication.startingDateTime) < lowerBoundDate
                ? new Date(leaveApplication.startingDateTime)
                : lowerBoundDate
            : lowerBoundDate
        minDate.setHours(0, 0, 0)
        if (leaveApplication.startingDateTime !== '' && leaveApplication.endingDateTime !== '') {
            if (!showShiftSection) {
                setShowShiftSection(true)
            }
            const startDate = new Date(leaveApplication.startingDateTime);  
            const endDate = new Date(leaveApplication.endingDateTime);
            

            const totalDays = getTotalDays(startDate, endDate)
            setTotalDays(totalDays)
        }

        const datePicker = flatpickr('.leave-request-range-date', {
            enableTime: true,
            dateFormat: 'm-d-Y h:iK',
            mode: 'range',
            defaultDate:
                leaveApplication.startingDateTime !== '' && leaveApplication.endingDateTime !== ''
                    ? [
                          new Date(leaveApplication.startingDateTime),
                          new Date(leaveApplication.endingDateTime),
                      ]
                    : undefined,
            minDate: minDate,
            onClose: (selectedDates) => {
                updateRequester()
                if (!selectedDates[0] || !selectedDates[1]) return

                updateDates(selectedDates[0], selectedDates[1])
                totalDays = getTotalDays(selectedDates[0], selectedDates[1])

                if (!showShiftSection) {
                    setShowShiftSection(true)
                }
                setTotalDays(totalDays)
                setdateError(false)
            },
        })
        clearDatesForDatePicker(datePicker)
        return () => {
            if (Array.isArray(datePicker)) {
                datePicker.forEach((instance) => instance.destroy())
            } else {
                datePicker.destroy()
            }
        }
    }, [lmsId,clearClicked])

    const stableStartDateTime = useMemo(
        () => new Date(leaveApplication.startingDateTime),
        [leaveApplication.startingDateTime]
    )

    const stableEndDateTime = useMemo(
        () => new Date(leaveApplication.endingDateTime),
        [leaveApplication.endingDateTime]
    )
    const clearDatesForDatePicker = (datePicker: any) => {
        if (leaveApplication.startingDateTime === '' && leaveApplication.endingDateTime === '') {
            datePicker.clear()
        } else {
            datePicker.setDate(
                [
                    new Date(leaveApplication.startingDateTime),
                    new Date(leaveApplication.endingDateTime),
                ],
                true
            )
        }
    }
    useEffect(() => {
        if (updateClicked) {
            updateAvailability()
        }
    }, [updateClicked])
    const updateAvailability = () => {
        if (leaveApplication.startingDateTime !== '' && leaveApplication.endingDateTime !== '') {
            updateRequester()
            if (!showShiftSection) {
                setShowShiftSection(true)
            }
        }
    }
    const updateRequester = () => {
        if (requester) {
            const newRequester = {
                id: requester.id,
                jsonSafeId: Number(requester.jsonSafeId),
                displayName: requester.displayName,
            }
            setLeaveApplication((prevState) => ({
                ...prevState,
                requester: newRequester,
            }))
        }
    }

    const updateDates = (startDate: Date, endDate: Date) => {
        setLeaveApplication((prev: any) => ({
            ...prev,
            startingDateTime: startDate ? changeDateTimeFormat(startDate.toISOString()) : null,
            endingDateTime: endDate ? changeDateTimeFormat(endDate.toISOString()) : null,
        }))
    }

    const getTotalDays = (start: any, end: any) => {
        if (!start || !end) return 1;
        // Pass the actual Date objects to moment
        const startMoment = moment(start).startOf('day'); // Using startOf('day') to remove time component
        const endMoment = moment(end).startOf('day'); // Using startOf('day') to remove time component
        return endMoment.diff(startMoment, 'days') + 1 || 1;
    };

    const resetForm = (
        dispatch: any,
        setLeaveApplication: any,
        setTotalDays: any,
        setShowShiftSection: any,
        setComment: any,
        setClearClicked:any
    ) => {
        dispatch(clearLmsId())
        dispatch(setnewForm(true))
        if (leaveApplication.id) {
            setLeaveApplication(initialLeaveApplication)
        }
        setTotalDays(0)
        setShowShiftSection(false)
        setComment('')
        setLeaveApplication((prev: LeaveManagerApiDTO_LeaveApplication) => ({
            ...prev,
            vacationType: 1,
            startingDateTime:'',
            endingDateTime:''

        }))
        clearClicked ? setClearClicked(false) : setClearClicked(true)
    }
    // Helper function to create comment object
    const createCommentObject = (comment: string, requestId: number,currentUserData:any) => {
        if (!comment) return null

        return {
            id: -1,
            requestId: requestId || -1,
            ts_creationDateTime: new Date(),
            postedBy: {
                id: currentUserData.providerId,
                displayName: currentUserData.AccountInfo?.name,
                jsonSafeId: currentUserData.providerId,
            },
            postedByUser: { id: -1, displayName: '', jsonSafeId: -1 },
            Comment: comment,
        }
    }
    const updateExistingLeaveRequest = async (
        leaveRequest: LeaveManagerApiDTO_LeaveApplication,
        requestId: number | string
    ) => {
        return await CreateOrUpdateLeaveRequest({
            type: 'PUT',
            requestId,
            leaveRequest,
        }).unwrap()
    }

    const createNewLeaveRequest = async (leaveRequest: LeaveManagerApiDTO_LeaveApplication) => {
        return await CreateOrUpdateLeaveRequest({
            type: 'POST',
            requestId: '',
            leaveRequest,
        }).unwrap()
    }
    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        const application_status = e.currentTarget.dataset.custom
        if (application_status !== 'save' && (leaveApplication.startingDateTime === '' || leaveApplication.endingDateTime === '')) {
            setdateError(true);  // Show error message if dates are missing
            return;  // Don't proceed further, just return to prevent the loading state
        }
        setIsLoadingButton(application_status);
        setError('')
        updateRequester()
        if (application_status === 'clear') {
            resetForm(dispatch, setLeaveApplication, setTotalDays, setShowShiftSection, setComment,setClearClicked)
            setIsLoadingButton(null);
            setcanEditProvider(true)
            return
        }

        // Validate dates
        if (
            application_status !== 'save' &&
            (leaveApplication.startingDateTime === '' || leaveApplication.endingDateTime === '')
        ) {
            setdateError(true)
            return
        }

        // Prepare payload
        const newCommentObj = createCommentObject(comment, leaveApplication.id || -1, currentUserData)
        const oldLeaveDetails = leaveApplication
        const payloadLA = {
            ...leaveApplication,
            comments: [
                ...(leaveApplication.comments || []),
                ...(newCommentObj ? [newCommentObj] : []),
            ],
        }

        // Handle status update if not saving
        if (application_status !== 'save') {
            const newStatus = genericValueToEnum(
                FoundationsEnums.LMS_LeaveRequestStatus,
                application_status || FoundationsEnums.LMS_LeaveRequestStatus.Decline
            )
            if (newStatus !== undefined) {
                payloadLA.requestStatus = newStatus
            }
        }

        try {
            let res
            if (
                application_status === 'save' &&
                leaveApplication.id !== null &&
                leaveApplication.id !== undefined
            ) {
                // Update existing leave request
                res = await updateExistingLeaveRequest(payloadLA, leaveApplication.id)
                setLeaveApplication(res)
            } else if (leaveApplication.id) {
                // Update with status change
                res = await updateExistingLeaveRequest(payloadLA, leaveApplication.id)
                setLeaveApplication(res)
            } else {
                // Create new leave request
                res = await createNewLeaveRequest(payloadLA)
                setLeaveApplication(res)
                setcanEditProvider(false)
            }

            if (res?.MessageResults?.length) {
                let isToasterDisplayed = false; // Flag to track toaster display
                res.MessageResults.forEach((result: any) => {
                    if (result.HelpMessage === FoundationsEnums.Status.Success && !isToasterDisplayed) {
                        if (application_status === 'save') {
                            FoundationsGenericToaster(
                                'success',
                                formType === 'approver'
                                    ? 'Leave request updated'
                                    : 'Leave request sent'
                            )
                        } else {
                            FoundationsGenericToaster('success', getStatusMessage(application_status))
                            setShowShiftSection(true)
                            setComment('')
                        }
                        isToasterDisplayed = true; // Mark toaster as displayed
                    } else if (result.HelpMessage !== FoundationsEnums.Status.Success) {
                        setError(result.Message)
                        setLeaveApplication(oldLeaveDetails)
                        setShowShiftSection(false)
                        setTotalDays(0)
                    }
                })
            }
        } catch (error: any) {
            FoundationsGenericToaster('error', 'Error occurred!')
            setError(error)
        }
        finally {
            // Reset the loading state after the mutation is complete
            setIsLoadingButton(null);
          }
    }
    const getStatusMessage = (status: any) => {
        switch (status) {
            case 'Approved':
                return 'Leave request approved'
            case 'Decline':
                return 'Leave request declined'
            case 'Withdrawn':
                return 'Leave request withdrawn'
            case 'Drafted':
                return 'Leave request draft saved'
            default:
                return formType == 'approver' ? 'Leave request updated' : 'Leave request sent'
        }
    }

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchText = e.target.value.trim()
        setSearchText(searchText)

        if (searchText === '') {
            setRequesters(originalRequesters)
        } else {
            setRequesters(
                originalRequesters.filter((requester) =>
                    requester.value.toLowerCase().includes(searchText.toLowerCase())
                )
            )
        }
    }

    const updateVacationType = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setLeaveApplication((prev: LeaveManagerApiDTO_LeaveApplication) => ({
            ...prev,
            vacationType: Number(e.target.value),
        }))
    }

    const handleRequesterSelect = (key: number | string) => {
        setSelectedRequesterKey(key) // Update the selected requester key
    }

    const handleUpdate = () => {
        setupdateClicked(true)
        if (selectedRequesterKey) {
            const selectedRequester = requesters?.find(
                (requester) => requester.key === selectedRequesterKey
            )
            if (selectedRequester) {
                setRequester({
                    jsonSafeId: Number(selectedRequester.key),
                    id: Number(selectedRequester.key),
                    displayName: selectedRequester.value,
                })
                let newSelectedRequester = {
                    jsonSafeId: Number(selectedRequester.key),
                    id: Number(selectedRequester.key),
                    displayName: selectedRequester.value,
                }
                setLeaveApplication((prevState) => ({
                    ...prevState,
                    requester: newSelectedRequester,
                }))
            }
        }
        setShowDialog(false)
    }

    const handleCommentChange = (e: any) => {
        const commentText = e.target.value.trim()
        setComment(commentText)
    }

    const changeDateTimeFormat = (dateTime: string, timezone = '', optionalFormat = '') => {
        return moment(dateTime).format(optionalFormat || 'MM/DD/YYYY hh:mm:ss A')
    }

    return (
        <>
            <main className="row leave-management pt-3 pb-3 mx-0" ref={inputRef}>
                <section className="col-12 col-md-12 col-lg-3">
                    <div className="row">
                        {canEditProvider && !lmsId && (
                            <span
                                className="hl-ui-editable-container w-100 mt-1 ml-1 cursor-pointer margin-bottom-medium"
                                onClick={() => setShowDialog(true)}
                            >
                                <div
                                    id="requester-select"
                                    className="hl-ui-editable select-text"
                                    style={{ marginRight: '20px' }}
                                >
                                    {leaveApplication.requester.displayName}
                                </div>
                                <span id="requester-id" className="hide">
                                    {leaveApplication.requester.id}
                                </span>
                            </span>
                        )}
                    </div>
                    <div className="input-section row" id="leave-request-info-section">
                        {formType === 'approver' && (
                            <>
                                <div className="col-5">
                                    <span id="test">Requesting Staff Name:</span>
                                </div>
                                <div className="col-7">
                                    <span id="staff-name">
                                        {leaveApplication.requester.displayName}
                                    </span>
                                </div>
                            </>
                        )}
                        <div className="col-5">
                            <span>Request ID:</span>
                        </div>
                        <div className="col-7">
                            <span id="request-id">
                                {leaveApplication.id === -1 ? '' : leaveApplication.id}
                            </span>
                        </div>
                        {leaveApplication.requestStatus !== 5 && (
                            <>
                                <div className="col-5">
                                    <span id="test">Type:</span>
                                </div>
                                <div className="col-7">
                                    <span>{vacationTypeLabel}</span>
                                </div>
                            </>
                        )}
                        <div className="col-5">
                            <span>Status:</span>
                        </div>
                        <div className="col-7">
                            <span id="status">
                                {
                                    settings.leaveStatusList[leaveApplication.requestStatus - 1]
                                        ?.Status
                                }
                            </span>
                        </div>
                        <div className="col-5">
                            <span>Created On:</span>
                        </div>
                        <div className="col-7">
                            <span id="create-on">
                                {formatDate(leaveApplication.ts_creationDateTime)}
                            </span>{' '}
                        </div>
                        <div className="col-5">
                            <span>Modified On:</span>
                        </div>
                        <div className="col-7">
                            <span id="modified-on">
                                {formatDate(leaveApplication.ts_modificationDateTime)}
                            </span>
                        </div>
                        {leaveApplication?.modifiedByUser?.id !== -1 && (
                            <>
                                <div className="col-5">
                                    <span>Last updated by:</span>
                                </div>
                                <div className="col-7">
                                    <span id="modified-on">
                                        {leaveApplication?.modifiedByUser?.displayName}
                                    </span>
                                </div>
                            </>
                        )}
                        {leaveApplication?.approvedByUser &&
                            leaveApplication?.approvedByUser.id !== -1 && (
                                <>
                                    <div className="col-5">
                                        <span>Leave Approved by:</span>
                                    </div>
                                    <div className="col-7">
                                        <span id="modified-on">
                                            {leaveApplication?.approvedByUser.displayName}
                                        </span>
                                    </div>
                                </>
                            )}
                    </div>
                    <div className="row pt-3 pb-3 mx-0">
                        <div
                            className="col-12 col-md-12 col-lg-12 field-validation-error"
                            style={{ color: 'red' }}
                            id="erroint"
                        >
                            {error}
                        </div>
                    </div>
                </section>

                {/* Middle Section */}
                <section className="col-12 col-md-12 col-lg-6 px-0">
                    <div className="row no-gutters">
                        <div className="col-12 input-section mb-3">
                            <div className="row no-gutters">
                                <div className="col-4 pt-2">Leave Type:</div>
                                <div className="col-8">
                                    <select
                                        id="leave_vacation_type_el"
                                        disabled={formType === 'approver'}
                                        title={
                                            formType === 'approver'
                                                ? 'Cannot change leave type during approval'
                                                : undefined
                                        }
                                        style={{ width: '100%' }}
                                        onChange={updateVacationType}
                                    >
                                        {settings.vacationTypes.map((type: any) => (
                                            <option
                                                key={type.id}
                                                value={
                                                    newForm
                                                        ? type.id
                                                        : leaveApplication.vacationType
                                                }
                                            >
                                                {type.Label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mb-3">
                            <div className="lms-panel site-time mt-0">
                                <div className="row no-gutters">
                                    <div className="col-4 pt-2">Date Range:</div>
                                    <div className="col-8 px-2">
                                        <FoundationsInput
                                            id="vac_range_el"
                                            type="text"
                                            name="vacationRange"
                                            inputClasses="leave-request-range-date mt-2 b-white border-none border-radius-none"
                                            inputStyle={{
                                                width: '100%',
                                                padding: '.4rem',
                                                fontSize: '16px',
                                                cursor: 'pointer',
                                                border: '1px solid #767676',
                                            }}
                                            SkipDline={true}
                                            containerClasses=""
                                            validationMessage="true"
                                            value={
                                                leaveApplication?.startingDateTime
                                                    ? formatDate(
                                                          leaveApplication.startingDateTime
                                                      ) +
                                                      ' to ' +
                                                      formatDate(leaveApplication.endingDateTime)
                                                    : ''
                                            }
                                        ></FoundationsInput>
                                    </div>
                                    <div className="col-4"></div>
                                    <div className="col-8 pt-2 px-2">
                                        {dateError && (
                                            <div id="leave_dates_error" style={{ color: 'red' }}>
                                                Please select valid beginning and ending dates for
                                                your PTO.
                                            </div>
                                        )}
                                        <span>Total Days: </span>
                                        <span className="wlm-sm" id="total_days">
                                            {totalDays}
                                        </span>
                                    </div>
                                    <div className="col-12 mt-2" style={{ overflowY: 'auto' }}>
                                        <div id="shifts_breakup" style={{ textAlign: 'center' }}>
                                            {showShiftSection && (
                                                <ShiftSection
                                                    formType={formType}
                                                    requesterId={leaveApplication.requester.id}
                                                    startDateTime={stableStartDateTime}
                                                    endDateTime={stableEndDateTime}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="col-12 col-md-12 col-lg-3">
                    <div className="row input-section mb-3">
                        <div className="col-12">Comments</div>
                        <div className="col-12">
                            <div id="lms_comment_form" className="pt-2 pb-3">
                                <FoundationsTextArea
                                    id="leave_requent_el"
                                    type="text"
                                    name="sql_filter"
                                    onInput={handleCommentChange}
                                    placeHolder="Please enter a note before an action."
                                    errorClasses="col-lg-12"
                                    inputClasses="lms-textarea"
                                    value={comment || ''}
                                    maxLength={250}
                                    containerClasses="d-inline-block lms-textarea"
                                    validationMessage="true"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row input-section mb-3">
                        <div className="col-12">Previous Notes:</div>
                        <div
                            className="col-12"
                            id="comment-section"
                            style={{ maxHeight: '250px', overflowY: 'auto' }}
                        >
                            {leaveApplication.comments?.map((comment: any, index) => (
                                <div
                                    key={index}
                                    style={{
                                        float:
                                            comment.postedByUser.id === currentUserData.id
                                                ? 'right'
                                                : 'left',
                                        background:
                                            comment.postedByUser.id === currentUserData.id
                                                ? '#e5f5ff'
                                                : '#cde7ba',
                                        border:
                                            comment.postedByUser.id === currentUserData.id
                                                ? '1px solid wheat'
                                                : '1px solid green',
                                        borderRadius: '5px',
                                        width: '80%',
                                        padding: '4px',
                                        marginBottom: '5px',
                                        color: '#60686d',
                                        marginLeft: '20px',
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: 'x-small',
                                            color: '#656c71',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {comment.postedBy.displayName}
                                    </div>
                                    <div className="text-break" style={{ wordBreak: 'break-word' }}>
                                        {comment.Comment}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: 'x-small',
                                            color: '#656c71',
                                        }}
                                    >
                                        {formatDate(comment.ts_creationDateTime)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="row input-section">
                        {leaveApplication.requestStatus !== 5 && (
                            <div className="col-6">
                                <FoundationsButton
                                    buttonClasses="w-75 text-center leave_button_container p-1 w-100 btn_lms app-button leave_button"
                                    id="button_save"
                                    onClick={handleSubmit}
                                    data={'save'}
                                >
                                    Save
                                </FoundationsButton>
                            </div>
                        )}
                        {settings.leaveStatusList.map(
                            (status: any, index: number) =>
                                status.ShowOnFormType.includes(formType) &&
                                status.Showifinstate.includes(leaveApplication.requestStatus) && (
                                    <div key={index} className="col-6">
                                        <FoundationsButton
                                            onClick={handleSubmit}
                                            buttonClasses="w-75 text-center leave_button_container p-1 app-button leave_button w-100 btn_lms"
                                            id={`${status.Status}`}
                                            data={status.Status}
                                        >
                                            {status.Label}
                                        </FoundationsButton>
                                    </div>
                                )
                        )}
                        <div className="col-6">
                            <FoundationsButton
                                buttonClasses="w-75 text-center leave_button_container p-1 app-button leave_button w-100 btn_lms"
                                id="button_clear"
                                data={'clear'}
                                isLoading={false}
                                onClick={handleSubmit}
                            >
                                Clear
                            </FoundationsButton>
                        </div>
                    </div>
                </section>
            </main>
            {showDialog && (
                <Dialog
                    width={540}
                    minHeight={42}
                    isOpen={showDialog}
                    title="Select from list below"
                    height={'auto'}
                    onClose={() => setShowDialog(false)}
                    buttons={[
                        {
                            label: 'Close',
                            onClick: () => setShowDialog(false),
                            className: 'app-button negative ui-button ui-corner-all ui-widget',
                        },
                        {
                            label: 'Update',
                            onClick: handleUpdate,
                            className: 'app-button ui-button ui-corner-all ui-widget',
                        },
                    ]}
                >
                    <div
                        id="hl_ui_searchlist_dialog_wrapper"
                        className="popup-wrapper ui-dialog-content ui-widget-content"
                        style={{ display: 'block' }}
                    >
                        <div id="hl_ui_searchlist_quick_search" className="quick-search">
                            <div className="search-text-wrapper">
                                <span className="search-image"></span>
                                <input
                                    type="text"
                                    id="hl_ui_searchlist_searchtext"
                                    name="searchText"
                                    placeholder="search..."
                                    value={searchText}
                                    onChange={handleSearch}
                                    className="input-text"
                                />
                                <span className="clear-both"></span>
                            </div>
                            <ol id="hl_ui_searchlist_list" className="vu-list">
                                {requesters?.map((requester: Requester) => (
                                    <li
                                        key={requester.key}
                                        id={`hl_ui_listitem_${requester.key}`}
                                        className={`ui-not-selected ${
                                            selectedRequesterKey === requester.key ? 'selected' : ''
                                        }`}
                                        onClick={() => handleRequesterSelect(requester.key)}
                                    >
                                        <div className="float-left fieldradio">
                                            <input
                                                type="radio"
                                                id={`hl_ui_listitem_radio_${requester?.key}`}
                                                onChange={() =>
                                                    handleRequesterSelect(requester.key)
                                                }
                                                name="hl_ui_listitem_radio"
                                                value={requester.key}
                                            />
                                        </div>
                                        <div className="float-left fieldcontent">
                                            <div
                                                id={`hl_ui_listdisplayvalue_${requester?.key}`}
                                                className="vu-lh"
                                            >
                                                {requester.value}
                                            </div>
                                        </div>
                                        <div className="clear-both"></div>
                                    </li>
                                ))}
                            </ol>
                        </div>

                        <div
                            id="valmsg_hl_ui_searchlist_list"
                            className="padding-top-small field-validation-error"
                        ></div>
                        <div
                            id="hl_ui_searchlist_loading"
                            className="hide ajax-loading-box popup-loading"
                        >
                            <span className="ajax-loading-image"></span>Saving...
                        </div>
                    </div>
                </Dialog>
            )}
        </>
    )
}
export default LeaveManagementForm
